import { NotificationsState } from './types'

export const state: NotificationsState = {
  notifications: { notificationsPrevious: [], notificationsToday: [] },
  loading: false,
  loadingInfo: false
}
